import { AfterViewInit, Component, ElementRef, inject, input, Input, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { appPaths } from '../../../../app.paths';
import list, { hcpLinks, spanishLinks } from '../nav-links';
import { HelpersService } from '../../../services/helpers.service';
import { GlobalModalService } from '../../../services/global-modal.service';

@Component({
  selector: '[menu-desktop]',
  imports: [CommonModule, RouterModule, NgbDropdownModule],
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.scss'],
  host: {
    class: 'd-none d-lg-block'
  }
})
export class MenuDesktopComponent implements AfterViewInit {

  private helpersService = inject(HelpersService);
  private globalModalService = inject(GlobalModalService);

  @ViewChildren('dropdownItems') dropdownItems!: QueryList<ElementRef>;

  appPaths = appPaths;
  list = list;
  hcpLinks = hcpLinks;
  spanishLinks = spanishLinks;

  //variables
  @Input() isWhiteNav: boolean = true;
  @Input() isSpanish!: boolean;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }

  isDropdownActive(dropdownList: { name: string; path: string }[] = []): boolean {
    return dropdownList?.some(dropdownItem => this.router.url.includes(dropdownItem.path)) ?? false;
  }

  isHcpLinkActive(path: string): boolean {
    return this.router.url.includes(path);
  }

  scrollToSection(id: string) {
    // console.log('clicked');
    const element = document.getElementById(id);
    if(!this.helpersService.validatePlatform()) return;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  spanishLink(url: string) {
    this.globalModalService.openModal('interstitialLongSp', url)
  }

  openHcpLink(path: string, e: Event) {
    e.preventDefault();
    this.globalModalService.openModal('interstitialHCP', `/${path}`);
  }

  onClick(ul:string, e: Event) {
    if (ul === 'resources') {
      e.preventDefault();
      this.globalModalService.openModal('interstitialHCP', `/${appPaths.RESOURCE}`);
    }
  }

}
